export enum ModalTypes {
    welcomeMsg = 'welcome',
    continueMsg = 'continue',
    wizardSetup = 'wizard',
    hidden = ''
}
